import React, { useRef, useEffect } from "react";
import "./index.css";
import IconRoundButton from "../../_utils/CommonButtons/IconRoundButton";
import PrimaryButton from "../../_utils/CommonButtons/PrimaryButton";
import SingleSelectDropDownComponent from "../../_utils/CommonDropdown/SingleSelectDropdown";

const SelectColumns = ({
  dropdownStates,
  setDropdownStates,
  selectedValues,
  columnsData,
  isFirstConfirmed,
  sortOptions,
  selectedColumns,
  toggleDropdown,
  handleOptionSelect,
  handleClearFilter,
  handleSelectColumn,
  handleSelectAllColumn,
  handleClearColumns,
  handleClearSort,
  handleEditSort,
  selectedOption,
}) => {
  const hasAdditionalColumnsSelected = () => {
    if (selectedOption === "User") {
      const selectedColumns = columnsData.filter(
        (data) => data?.selected === true,
      );
      return (
        selectedColumns.length > 1 ||
        (selectedColumns.length === 1 &&
          selectedColumns[0].columnName !== "User name")
      );
    } else if (selectedOption === "Bank statement") {
      const selectedColumns = columnsData.filter(
        (data) => data?.selected === true,
      );
      return (
        selectedColumns.length > 1 ||
        (selectedColumns.length === 1 &&
          selectedColumns[0].columnName !== "Account Id")
      );
    } else {
      return columnsData.some((data) => data?.selected === true);
    }
  };
  const dropdown1Ref = useRef(null);
  const dropdown2Ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdown1Ref.current &&
        !dropdown1Ref.current.contains(event.target)
      ) {
        if (dropdownStates.dropdown1) {
          setDropdownStates((prev) => ({ ...prev, dropdown1: false }));
        }
      }

      if (
        dropdown2Ref.current &&
        !dropdown2Ref.current.contains(event.target)
      ) {
        if (dropdownStates.dropdown2) {
          setDropdownStates((prev) => ({ ...prev, dropdown2: false }));
        }
      }
    };

    if (dropdownStates.dropdown1 || dropdownStates.dropdown2) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownStates.dropdown1, dropdownStates.dropdown2, setDropdownStates]);

  return (
    <div
      className={`ml-margin-sm  mr-margin-sm Qmd:ml-margin-xs Qmd:mr-margin-xs h-fit  mb-margin-xl Qmd:mb-margin-base`}
    >
      <div className="flex flex-col relative gap-gap-md pb-padding-xl mb-margin-md">
        <div className=" rounded-border-radius-md bg-primary-card Qmd:h-fit">
          <div className="flex justify-between  pt-padding-md px-padding-md ">
            <div className="flex flex-col gap-gap-xs">
              <p className="text-text-primary text-font-md font-semibold">
                Columns
              </p>
              <span className="text-text-secondary text-font-xs font-normal ">
                Selected columns will appear on the MIS report.
              </span>
            </div>

            <div className="flex gap-gap-sm">
              <IconRoundButton
                enabledBgColor="var(--primary-bg)"
                isLoading={false}
                handleFunction={() => handleSelectAllColumn()}
                icon={
                  columnsData.every((data) => data?.selected === true)
                    ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                    : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg"
                }
                hoverOption="white"
                title="check-icon"
              />
            </div>
          </div>
          <div className="select-column-container">
            {columnsData?.map((fileds, index) => {
              return (
                <div
                  className={`select-column-cards flex justify-center items-center pl-padding-sm pr-padding-sm cursor-pointer relative z-z-index-base ${
                    fileds?.selected
                      ? `bg-positive-bg ${
                          (selectedOption === "User" &&
                            fileds?.columnName === "User name") ||
                          (selectedOption === "Bank statement" &&
                            fileds?.columnName === "Account Id")
                            ? ""
                            : "global-hover-black"
                        } `
                      : "bg-primary-nav-act global-hover-white"
                  }
                  `}
                  key={index}
                  onClick={() => handleSelectColumn(fileds?.columnId)}
                  style={{
                    cursor:
                      (selectedOption === "User" &&
                        fileds?.columnName === "User name") ||
                      (selectedOption === "Bank statement" &&
                        fileds?.columnName === "Account Id")
                        ? "not-allowed"
                        : "pointer",
                    height: "var(--dropdown-option-height-sm)",
                  }}
                >
                  <p
                    className="text-text-primary text-font-xs  font-normal truncate"
                    title={fileds?.columnName}
                  >
                    {fileds?.columnName}
                  </p>

                  <div
                    className={`my-auto ${
                      fileds?.columnName !== "User name" &&
                      !(
                        selectedOption === "Bank statement" &&
                        fileds?.columnName === "Account Id"
                      )
                        ? "visible"
                        : "invisible"
                    }`}
                  >
                    <img
                      src={`${
                        fileds?.selected ||
                        (selectedOption === "User" &&
                          fileds?.columnName === "User name") ||
                        (selectedOption === "Bank statement" &&
                          fileds?.columnName === "Account Id")
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                      }`}
                      alt="check-icon"
                      className="select-column-cards-check"
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="confirm-container">
            <div className="flex gap-gap-md">
              <PrimaryButton
                enabledBgColor=""
                btnText="Clear"
                outLineColor="var(--text-primary)"
                enabledTextColor="var(--text-primary)"
                handleFunction={() => handleClearColumns()}
                hoverOption="white"
                isDisabled={!hasAdditionalColumnsSelected()}
              />
            </div>
          </div>
        </div>
        <div
          className="Qmd:h-fit relative rounded-border-radius-md bg-primary-card  py-padding-md px-padding-md overflow-visible"
          style={{
            opacity:
              selectedOption === "User" ||
              selectedOption === "Bank statement" ||
              (isFirstConfirmed &&
                columnsData.some((data) => data?.selected === true))
                ? "var(--base-opacity)"
                : "var(--light-opacity)",
            pointerEvents:
              selectedOption === "User" ||
              selectedOption === "Bank statement" ||
              (isFirstConfirmed &&
                columnsData.some((data) => data?.selected === true))
                ? "auto"
                : "none",
          }}
        >
          <div className="flex justify-between gap-gap-xs flex-col">
            <p className="text-text-primary text-font-md font-semibold">
              Sort By (Optional)
            </p>
            <span className="text-text-secondary text-font-xs  font-normal">
              MIS report will be sorted by the order that has been selected
              below.
            </span>
          </div>

          {true ? ( // Always show dropdowns (edit mode)
            <div className="flex flex-col Qmd:flex-row gap-gap-md  mt-margin-md">
              <div>
                <p className="text-font-xs text-text-secondary">Column</p>
                <div
                  className="relative mt-margin-xs Qmd:w-txn-card-width "
                  ref={dropdown1Ref}
                ></div>

                <SingleSelectDropDownComponent
                  options={selectedColumns.map((col) => col.columnName)}
                  selected={selectedValues.dropdown1}
                  setSelected={(value) =>
                    handleOptionSelect("dropdown1", value)
                  }
                  type="small"
                  showSearch={false}
                  placeholder="Select"
                  searchPlaceholder=""
                  disabled={false}
                />
              </div>
              <div>
                <p className="text-font-xs text-text-secondary">
                  Select field to sort the report by
                </p>
                <div
                  className="relative mt-margin-xs Qmd:w-txn-card-width "
                  ref={dropdown2Ref}
                ></div>
                <SingleSelectDropDownComponent
                  options={sortOptions}
                  selected={selectedValues.dropdown2}
                  setSelected={(value) =>
                    handleOptionSelect("dropdown2", value)
                  }
                  type="small"
                  showSearch={false}
                  placeholder="Select"
                  searchPlaceholder=""
                  disabled={false}
                />
              </div>
            </div>
          ) : (
            <div className="flex flex-wrap gap-gap-md pt-padding-md">
              {selectedValues.dropdown1 !== "" && (
                <div className="select-column-cards bg-primary-nav-act cursor-pointer global-hover-white  flex justify-center items-center pl-padding-sm: pr-padding-sm">
                  <p className="text-text-primary text-font-xs font-normal">
                    {selectedValues.dropdown1}
                  </p>
                </div>
              )}
              {selectedValues.dropdown2 !== "" && (
                <div className="select-column-cards bg-primary-nav-act cursor-pointer global-hover-white  flex justify-center items-center pl-padding-sm: pr-padding-sm">
                  <p className="text-text-primary text-font-xs font-normal">
                    {selectedValues.dropdown2}
                  </p>
                </div>
              )}
            </div>
          )}

          <div className="flex justify-end  gap-gap-md mt-margin-button-l">
            <PrimaryButton
              enabledBgColor=""
              btnText="Clear"
              outLineColor="var(--text-primary)"
              enabledTextColor="var(--text-primary)"
              handleFunction={handleClearSort}
              hoverOption="white"
              isDisabled={
                !(
                  selectedValues.dropdown1 !== "" ||
                  selectedValues.dropdown2 !== ""
                )
              }
            />
          </div>
        </div>
        <div className="h-pagination-height mb-margin-lg"></div>
      </div>
    </div>
  );
};

export default SelectColumns;
